import {
  Cookie as CookieClient,
  createRealTimeCookie,
} from '@cookie-baker/browser';
import { reatomCookie } from '@reatom/npm-cookie-baker';

type AppBannerModel = {
  appBannerIsHide?: string;
};

const cookie = new CookieClient<AppBannerModel>();
const realTimeCookie = createRealTimeCookie(cookie);

export const appBannerAtom = reatomCookie(cookie, realTimeCookie);
